<template>
  <div class="row">
    <div class="col">
      <hole-column
        @click="onClick($event, flight, flightIndex, hole)"
        v-if="hole"
        :classes="'mobile'"
        :hole="hole"
        :isStartHole="hole?.number == flight.startHole"
      ></hole-column>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import HoleColumn from "./hole_column.vue";

export default defineComponent({
  props: {
    flight: Object,
    flightIndex: Number,
    onClick: Function,
  },
  components: {
    HoleColumn,
  },
  computed: {
    ...mapGetters({
      selectedSingleHole: "navigation/getSelectedSingleHole",
    }),
    hole() {
      return this.holeByFlightAndNumber(
        this.flight,
        this.selectedSingleHole ?? 1
      );
    },
  },
  methods: {
    holeByFlightAndNumber(flight, number) {
      return flight?.holes?.find((h) => h.number === number);
    },
  },
});
</script>
